/** @file Field check for a nested object shape. */
import { expectShape } from '@zilo/pose3d-format/validate/fields/expectShape';
import type { FieldCheck, Shape } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** Check that `value` is an object fitting `shape`. */
export function checkShape(shape: Shape): FieldCheck {
  return (value, path) => { expectShape(value, path, shape); };
}
